<component-navbar *ngIf="showHeader"></component-navbar>
<router-outlet></router-outlet>